import { TranslatePipe } from '../../filters/translate.pipe';
import { LoaderOverlayComponent } from '../../components/loader-overlay/loader-overlay.component';
import { ListPagerComponent } from '../../components/list-pager/list-pager.component';
import { TableConsentsComponent } from '../../components/table-consents/table-consents.component';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import UserConsentRestServices from '../../services/user-consent-rest.service';
import Config from '../../utils/config.service';
import AngularHelperService from '../../services/angular-helper.service';
import AngularFilterHelperService from '../../services/angular-filter-helper.service';
import { Input } from '@angular/core';

@Component({
	standalone: true,
	selector: 'card-consents',
	templateUrl: './card-consents.component.html',
	imports: [ CommonModule, TranslatePipe, LoaderOverlayComponent, ListPagerComponent, TableConsentsComponent, FormsModule ]
})
export class CardConsentsComponent implements OnInit {
	private userConsentRestServices: UserConsentRestServices = inject(UserConsentRestServices);
	private config: Config = inject(Config);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	
	@Input() consentType: any | undefined;
	@Input() pageSize: any | undefined;
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.vm.consents = [];
		this.vm.pageSize = 10;
		this.vm.pageSize = this.vm.pageSize || 10;
		this.vm.currentPage = 0;
		this.vm.endReached = false;
		this.vm.loading = true;
		this.loadConsents(true);
	}
	
	currentPageChanged(newPage) {
		this.loadConsents();
	}
	
	loadConsents(isInitial?) {
		if (isInitial) {
			this.vm.endReached = false;
		} else if (this.vm.endReached) {
			this.vm.loading = false;
			return;
		}
		
		var requestParams: any = {
			pageSize: this.vm.pageSize * 2,
			start: (!isInitial && this.vm.consents) ? this.vm.consents.length : 0,
		};
		var callback = (consents) => {
			if (consents && consents.length < this.vm.pageSize * 2) {
				this.vm.endReached = true;
			}
			if (this.vm.consentType === 'general') {
				if (isInitial && !Array.isArray(consents)) consents = [consents];
				consents.map((item) => { item.description = this.angularFilterHelperService.translate('Consents.Table.MinuDoc_Consents'); });
			} else {
				consents.map((item) => { item.description = item.booking.service.user.firstname + ' ' + item.booking.service.user.lastname; });
			}
			
			this.vm.consents = isInitial ? consents : this.vm.consents.concat(consents);
			this.angularHelperService.createTimer(() => { this.vm.loading = false; }, this.config.getOtherConfig().LOADER_TIMEOUT_DELAY);
		};
		
		if (this.vm.consentType === 'general') {
			this.userConsentRestServices.getGeneralConsents(requestParams, callback);
		} else {
			this.userConsentRestServices.getBookingConsents(requestParams, callback);
		}
	}
	
}